module.exports = __webpack_public_path__ + "static/img/47.fcdc493.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Office365Deployment/47.png
// module id = X+c3
// module chunks = 1